import React from "react";
import emptyResults from "assets/img/no_results.png";

import "./style.scss";

export const EmptyResults = ({ labels }) => {
  
  return (
          <div>
            <div className="empty-results">{labels?.empty_reaults_text}</div>
            <img src={emptyResults} className="img-er" />
          </div>
  )
};